// Build a WhatsApp "click to chat" URL that opens with a pre-filled message
// Docs: https://faq.whatsapp.com/5913398998672934
export function waIntentionShareUrl({ title, description, requesterName, intentionId, origin }) {
    const base = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
    const link = intentionId ? `${base}/intentions?focus=${intentionId}` : `${base}/intentions`;
    const safeTitle = (title || "an intention").trim();
    const brief = (description || "").trim().split("\n")[0].slice(0, 180);
    const by = requesterName ? ` (asked by ${requesterName})` : "";
    const lines = [
        `🙏 Please pray with me:`,
        `*${safeTitle}*${by}`,
        brief ? `“${brief}”` : "",
        ``,
        `Join The Prayer Warriors and commit a prayer:`,
        link,
    ].filter(Boolean);
    const text = encodeURIComponent(lines.join("\n"));
    return `https://wa.me/?text=${text}`;
}
